/**
 * Herbaria | Produkttitel-Umbruch v5.0 – FINAL
 * Theme: Whisk 14.0.4 | Mobile only (max-width: 749px)
 * Datum: Mai 2026
 *
 * QUELLE DER WAHRHEIT: Shopify Product Export Mai 2026 (110 Artikel)
 *
 * PFLEGE bei neuen Produkten:
 * 1. Den Produkttitel exakt wie in Shopify hinzufügen
 * 2. <wbr>-Tags an Komposita-Grenzen einfügen
 * 3. Save → fertig
 */

(function () {
  'use strict';

  const TITLE_MAP = {

    // ─── PFEFFER ───
    'TRIO NOIR PFEFFER, ganze Körner':              'TRIO NOIR PFEFFER,<wbr> ganze Körner',
    'TELLICHERRY URWALDPFEFFER, ganze Körner':      'TELLI<wbr>CHERRY URWALD<wbr>PFEFFER,<wbr> ganze Körner',
    'KUBEBENPFEFFER, ganze Körner':                 'KUBEBEN<wbr>PFEFFER,<wbr> ganze Körner',

    // ─── SALZ ───
    'SIZILIANISCHES STEINSALZ':                     'SIZILIA<wbr>NISCHES STEIN<wbr>SALZ',

    // ─── EINZELGEWÜRZE ───
    'SAFRAN, Fäden':                                'SAFRAN, Fäden',
    'SAFRAN, gemahlen':                             'SAFRAN, gemahlen',
    'ZITRONENTHYMIAN':                              'ZITRONEN<wbr>THYMIAN',
    'THYMIAN':                                      'THYMIAN',
    'ROSMARIN':                                     'ROSMARIN',
    'OREGANO':                                      'OREGANO',
    'MAJORAN':                                      'MAJORAN',
    'LIEBSTÖCKEL':                                  'LIEB<wbr>STÖCKEL',
    'KÜMMEL, ganze Samen':                          'KÜMMEL,<wbr> ganze Samen',
    'KREUZKÜMMEL, ganze Samen':                     'KREUZ<wbr>KÜMMEL,<wbr> ganze Samen',
    'KORIANDER, ganze Samen':                       'KORIAN<wbr>DER,<wbr> ganze Samen',
    'FENCHEL, ganze Samen':                         'FENCHEL,<wbr> ganze Samen',
    "BIRD'S EYE CHILI, ganze Schoten":              "BIRD'S EYE CHILI,<wbr> ganze Schoten",
    'PETERSILIE':                                   'PETER<wbr>SILIE',
    'DILLSPITZEN':                                  'DILL<wbr>SPITZEN',
    'BASILIKUM':                                    'BASI<wbr>LIKUM',
    'PAPRIKA, edelsüß':                             'PAPRIKA, edelsüß',
    'KURKUMA':                                      'KURKUMA',
    'ZIMT':                                         'ZIMT',
    'SCHWARZKÜMMEL':                                'SCHWARZ<wbr>KÜMMEL',
    'WEIẞER SESAM':                                 'WEIẞER SESAM',
    'SCHWARZER SESAM':                              'SCHWAR<wbr>ZER SESAM',

    // ─── BIO-FEINSCHMECKER (Gewürzmischungen) ───
    'LANGZU BBQ':                                   'LANGZU BBQ',
    'EDLE ERNA':                                    'EDLE ERNA',
    'COFFEE BBQ':                                   'COFFEE BBQ',
    'TUTTO MIO!':                                   'TUTTO MIO!',
    'PIZZA E PASTA':                                'PIZZA E PASTA',
    'OH DU FRÖHLICHE':                              'OH DU FRÖH<wbr>LICHE',
    'GAUMENSCHMAUS':                                'GAUMEN<wbr>SCHMAUS',
    'SISSIS SÜND':                                  'SISSIS SÜND',
    'TAJINE MARRAKESCH':                            'TAJINE MARRA<wbr>KESCH',
    "ZA'ATAR":                                      "ZA'ATAR",
    'RUF DER OASE':                                 'RUF DER OASE',
    'KEBAP QUEEN':                                  'KEBAP QUEEN',
    'GROẞE KARAWANE':                               'GROẞE KARA<wbr>WANE',
    'HARISSA':                                      'HARISSA',
    'TRÜFFELGLÜCK':                                 'TRÜFFEL<wbr>GLÜCK',
    'MAESTRO DI BBQ':                               'MAESTRO DI BBQ',
    'HEUREKA!':                                     'HEUREKA!',
    'EIVOCADO':                                     'EIVOCADO',
    'GERDAS GARTEN':                                'GERDAS GARTEN',
    'OBAZD IS!':                                    'OBAZD IS!',
    'VEGGIE KICK':                                  'VEGGIE KICK',
    'KÜRBISKÖNIG':                                  'KÜRBIS<wbr>KÖNIG',
    'WIESN RESI':                                   'WIESN RESI',
    'GOMASIO':                                      'GOMASIO',
    'CAESAR SALAD':                                 'CAESAR SALAD',
    'MAPUCHE FEUER':                                'MAPUCHE FEUER',
    'CHILI CON CARLOS':                             'CHILI CON CARLOS',
    'TANGO SPICE':                                  'TANGO SPICE',
    'DUFT DER MACCHIA':                             'DUFT DER MACCHIA',
    'NEPTUNS TRAUM':                                'NEPTUNS TRAUM',
    'WILDE HILDE':                                  'WILDE HILDE',
    'WALDESLUST':                                   'WALDES<wbr>LUST',
    'FISCH AHOI':                                   'FISCH AHOI',
    'HIMMEL AUF ERDEN':                             'HIMMEL AUF ERDEN',
    'HOT APPLE CIDER':                              'HOT APPLE CIDER',
    'KNUSPERHEXE':                                  'KNUSPER<wbr>HEXE',
    'KLEINER LORD':                                 'KLEINER LORD',
    'RAS EL HANOUT':                                'RAS EL HANOUT',
    "ALL' ARRABBIATA":                              "ALL' ARRAB<wbr>BIATA",
    'RED HOT CHILI':                                'RED HOT CHILI',
    'GOOD OLD MILD':                                'GOOD OLD MILD',
    'FARBEN VON JAIPUR':                            'FARBEN VON JAIPUR',
    'BLACK MAGIC':                                  'BLACK MAGIC',
    'QUERBEET':                                     'QUERBEET',

    // ─── KAFFEE / ESPRESSO ───
    'MAKEDA Espresso ganze Bohnen':                 'MAKEDA Espresso<wbr> ganze Bohnen',
    'MAKEDA Espresso gemahlen':                     'MAKEDA Espresso<wbr> gemahlen',
    'BAHATI Kaffee ganze Bohnen':                   'BAHATI Kaffee ganze Bohnen',
    'BAHATI Kaffee gemahlen':                       'BAHATI Kaffee gemahlen',

    // ─── NATURAPOTHEKE ───
    'Bittrio':                                      'Bittrio',
    'Blutquick':                                    'Blutquick',

    // ─── TEES ───
    'Brennnesselkraut Tee Bioland':                 'Brennnessel<wbr>kraut Tee Bioland',
    'Brennnesselkraut Tee':                         'Brennnessel<wbr>kraut Tee',
    'Thymian Tee':                                  'Thymian Tee',
    'Salbeiblätter Tee':                            'Salbei<wbr>blätter Tee',
    'Löwenzahnkraut Tee':                           'Löwenzahn<wbr>kraut Tee',
    'Himbeerblätter Tee':                           'Himbeer<wbr>blätter Tee',
    'Fenchel Tee':                                  'Fenchel Tee',
    'Schafgarbenkraut Tee':                         'Schafgarben<wbr>kraut Tee',
    'Grüner Hafertee':                              'Grüner Hafer<wbr>tee',
    'Lindenblüten Tee':                             'Linden<wbr>blüten Tee',
    'Kamillenblüten Tee':                           'Kamillen<wbr>blüten Tee',
    'Basen-Kräutertee':                             'Basen-Kräuter<wbr>tee',
    'Anis-Fenchel-Kümmel-Tee':                      'Anis-Fenchel-Kümmel-Tee',
    'Fasten-Tee':                                   'Fasten-Tee',
    'Teemischung Brennnessel-Ingwer':               'Tee<wbr>mischung Brennnessel-Ingwer',
    'Teemischung Rose-Minze':                       'Tee<wbr>mischung Rose-Minze',
    'Teemischung Bergkräutertee':                   'Tee<wbr>mischung Berg<wbr>kräuter<wbr>tee',
    'Teemischung Roter Apfel':                      'Tee<wbr>mischung Roter Apfel',
    '6er Tee nach Eva Aschenbrenner':               '6er Tee nach Eva Aschen<wbr>brenner',
    'Kaltwettertee nach Eva Aschenbrenner':         'Kalt<wbr>wetter<wbr>tee nach Eva Aschen<wbr>brenner',
    '5er Tee nach Eva Aschenbrenner':               '5er Tee nach Eva Aschen<wbr>brenner',
    'Pfefferminz-Tee':                              'Pfeffer<wbr>minz-Tee',
    'Brennnessel-Tee':                              'Brennnessel-Tee',
    'Kamillen-Tee':                                 'Kamillen-Tee',
    'Hagebutte-Hibiskus-Tee':                       'Hagebutte-Hibiskus-Tee',
    'Salbei-Tee':                                   'Salbei-Tee',
    'Thymian-Tee':                                  'Thymian-Tee',
    'Im Wandel Wechseljahre Tee':                   'Im Wandel Wechsel<wbr>jahre Tee',
    'Für Dich Frauentee':                           'Für Dich Frauen<wbr>tee',
    'Voller Schwung Tee':                           'Voller Schwung Tee',
    'Warme Mitte Tee':                              'Warme Mitte Tee',
    'Stimmgold Tee':                                'Stimmgold Tee',
    'Ruhig & Gut Tee':                              'Ruhig & Gut Tee',
    'In Balance Tee':                               'In Balance Tee',
  };

  // ─── DOM Processing ─────────────────────────────────────
  function processElement(el) {
    if (el.dataset.titleWrapped === '1') return;
    if (el.children.length > 0) return;
    const raw = el.textContent.trim();
    if (!raw) return;
    if (TITLE_MAP[raw]) {
      el.innerHTML = TITLE_MAP[raw];
      el.dataset.titleWrapped = '1';
    }
  }

  function processAll() {
    document.querySelectorAll(
      '.product-card__title'
    ).forEach(processElement);
  }

  function observe() {
    new MutationObserver(mutations => {
      mutations.forEach(({ addedNodes }) => {
        addedNodes.forEach(node => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          node.querySelectorAll('.product-card__title')
            .forEach(processElement);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { processAll(); observe(); });
  } else {
    processAll();
    observe();
  }

})();